import styled from "styled-components";
import { COLORS, TYPOGRAPHY } from "../../containers/impact-report/constants";

const getVariantStyles = variant => {
  const variants = {
    positive: {
      backgroundColor: COLORS.POSITIVE_MUTED,
      color: COLORS.POSITIVE_BASE
    },
    primary: {
      backgroundColor: COLORS.PRIMARY_MUTED,
      color: COLORS.PRIMARY_BASE
    },
    secondary: {
      backgroundColor: COLORS.SECONDARY_MUTED,
      color: COLORS.SECONDARY_PRESS
    },
    neutral: {
      backgroundColor: COLORS.CONTENT_MUTED,
      color: COLORS.NEUTRAL_500
    }
  };

  return variants[variant];
};

export const BadgeWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  ${TYPOGRAPHY.BODY_SMALL_MEDIUM}
  background-color: ${props => getVariantStyles(props.variant).backgroundColor};
  color: ${props => getVariantStyles(props.variant).color};
`;
